import { ErrorCode } from '@kreart/shared';
import { makeErrorKeyResolver } from '@/lib/form/errorMessages';

export const errorKeyFor = makeErrorKeyResolver({
  [ErrorCode.PROJECTS_NOT_FOUND]: 'projects.errors.notFound',
  [ErrorCode.PROJECTS_INVALID_TRANSITION]: 'projects.errors.invalidTransition',
  [ErrorCode.PROJECTS_BACKWARD_TRANSITION_FORBIDDEN]: 'projects.errors.backwardForbidden',
  [ErrorCode.PROJECTS_REJECTION_DETAILS_REQUIRED]: 'projects.errors.rejectionRequired',
  [ErrorCode.PROJECTS_WORKER_FORBIDDEN_FIELD]: 'projects.errors.workerForbidden',
  [ErrorCode.PROJECTS_CLIENT_NOT_FOUND]: 'projects.errors.clientNotFound',
  [ErrorCode.PROJECTS_DELIVERY_ADDRESS_INVALID]: 'projects.errors.addressInvalid',
  [ErrorCode.PROJECTS_ASSIGNMENT_NOT_FOUND]: 'projects.errors.assignmentNotFound',
  [ErrorCode.PROJECTS_ASSIGNEE_NOT_WORKER]: 'projects.errors.assigneeNotWorker',
  [ErrorCode.PROJECTS_ASSIGNEE_INACTIVE]: 'projects.errors.assigneeInactive',
  [ErrorCode.NOT_FOUND]: 'projects.errors.notFound',
  [ErrorCode.ALREADY_EXISTS]: 'projects.errors.alreadyAssigned',
});
